import { render, staticRenderFns } from "./IArrow.vue?vue&type=template&id=cac5e13c&"
import script from "./IArrow.vue?vue&type=script&lang=ts&"
export * from "./IArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports